import { render } from "./CourseMore.vue?vue&type=template&id=15460b19&scoped=true"
import script from "./CourseMore.vue?vue&type=script&lang=js"
export * from "./CourseMore.vue?vue&type=script&lang=js"

import "./CourseMore.vue?vue&type=style&index=0&id=15460b19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15460b19"]])

export default __exports__